import { INetworkMidLevelMadlibModel, INetworkMidLevelFilterOption } from './../../network-mid-level.models';
import { Component, EventEmitter, HostListener, Output, Input } from '@angular/core';

@Component({
  selector: 'super-filter',
  template: require('./super-filter.component.html'),
  styles: [require('./super-filter.component.scss')],
})
export class SuperFilterComponent {
  @Input() filterOptions: Array<INetworkMidLevelFilterOption>;
  @Input() model: Partial<INetworkMidLevelMadlibModel>;
  @Input() filterLabel: string;
  @Input() pillLabel: string;
  @Input() isModified: boolean;
  @Output() filterUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirmation = new EventEmitter<any>();
  @Output() cancelation = new EventEmitter<any>();

  isSuperFilterOpen: boolean = false;
  multiMenuToShow: string | null = null; // hold the key of the multi menu to show
  multiMenuPos: string;

  @HostListener('document:click', ['$event'])
  clickOut(): void {
    this.multiMenuToShow = null;
  }

  public showMultiSelectMenu(key: string, event: Event): void {
    event.stopPropagation();
    const pillPos = (event.currentTarget as HTMLElement).getBoundingClientRect();

    // to close an open menu when the pill that opend the menu is clicked
    if (this.multiMenuToShow !== null) {
      this.multiMenuToShow = null;
    } else {
      // no menu is open. some pill just initiated a menu open event
      this.multiMenuToShow = key;
      const pillBottomMargin = 4; // this is the pill's bottom margin was specified in the css
      this.multiMenuPos = `${pillPos.top + pillPos.height + pillBottomMargin}px`;
    }
  }

  onMultiSelectMenuClick(event: Event): void {
    event.stopPropagation();
  }

  emitFilterUpdate(key, value) {
    this.filterUpdate.emit({ key, value });
  }

  emitCancelation(): void {
    this.cancelation.emit();
  }

  emitConfirmation(): void {
    this.confirmation.emit();
  }
}
